<template>
  <div class="ptlShell">
    <HubHeader :fixed="false" />
    <div class="ptlBody">
    <aside class="ptlSide">
      <div class="sideHead">
        <button type="button" class="brand" @click="moveList" title="프로토콜 목록으로 이동">
          <span class="brandText">프로토콜</span>
          <span class="brandSub">목록</span>
        </button>
      </div>

      <button type="button" class="newProtocolBtn" @click="createProtocol">
        <span class="btnCode">+</span> 새 프로토콜
      </button>

      <nav class="sideNav">
        <p class="navLabel">WORKSPACE</p>
        <button
          type="button"
          class="navItem"
          :class="{ on: isGate }"
          @click="moveList"
        ><span class="idx">01</span>프로토콜 목록</button>
        <button
          type="button"
          class="navItem"
          :class="{ on: isEditor }"
          :disabled="!isEditor && !recentProtocol"
          @click="openRecentProtocol"
        ><span class="idx">02</span>최근 편집</button>

        <!-- 수정 모드에서만 노출되는 편집 메뉴 -->
        <template v-if="isEditor && editorMode === 'edit'">
          <p class="navLabel">프로토콜 관리</p>
          <button
            type="button"
            class="navItem"
            @click="runEditorAction('connect')"
          ><span class="idx">03</span>공정도 연결</button>
          <button
            type="button"
            class="navItem"
            @click="runEditorAction('publish')"
          ><span class="idx">04</span>공개 설정</button>
          <button
            type="button"
            class="navItem"
            @click="runEditorAction('docOption')"
          ><span class="idx">05</span>문서설정</button>

          <p class="navLabel">편집</p>
          <button
            type="button"
            class="navItem"
            @click="runEditorAction('preview')"
          ><span class="idx">06</span>미리보기</button>
          <button
            type="button"
            class="navItem"
            @click="runEditorAction('readonly')"
          ><span class="idx">07</span>읽기모드 전환</button>
          <button
            type="button"
            class="navItem saveItem"
            @click="runEditorAction('save')"
          ><span class="idx">08</span>저장</button>
        </template>

        <!-- 읽기 모드(작성자)에서만 노출되는 관리 메뉴 -->
        <template v-if="isEditor && editorMode === 'readonly' && editorAuth">
          <p class="navLabel">프로토콜 관리</p>
          <button
            v-if="editorProtocolType !== 'UNIT'"
            type="button"
            class="navItem"
            @click="runEditorAction('utilizeList')"
          ><span class="idx">03</span>연결관리</button>
          <button
            type="button"
            class="navItem"
            @click="runEditorAction('editMode')"
          ><span class="idx">04</span>수정모드 전환</button>
          <button
            type="button"
            class="navItem"
            @click="runEditorAction('docInfo')"
          ><span class="idx">05</span>문서정보</button>
        </template>
      </nav>

      <div class="sideFoot">
        <button type="button" @click="moveHome">메인</button>
        <span class="sep"></span>
        <button type="button" @click="moveMypage">마이페이지</button>
        <span class="sep"></span>
        <a href="/m3dhub/tutorial/Hub_Manual.pdf" target="_blank">매뉴얼</a>
      </div>
    </aside>

    <main class="ptlMain">
      <router-view :key="routeViewKey" />
    </main>
    </div>

    <registDictionaryPopup
      :key="registDictionaryPopupKey"
      :forceReRender.sync="registDictionaryPopupKey"
    />
    <TagOptionPopTagAddList />
    <ExperimentType />
    <EditAttribute />
    <EditAttributePool />
    <ConnectProtocol />
    <SearchProtocol />
    <ProtocolDetail />
    <FileUpload />
  </div>
</template>

<script>
import TagOptionPopTagAddList from '@components/TagAddPop/TagOptionPopTagAddList';
import registDictionaryPopup from '@nav_process/Editor/comp/registDictionaryPopup';
import ExperimentType from '@/components/modal/ExperimentType';
import EditAttribute from '@/components/modal/EditAttribute';
import EditAttributePool from '@/components/modal/EditAttributePool';
import ConnectProtocol from '@/components/modal/ConnectProtocol';
import SearchProtocol from '@/components/modal/SearchProtocol';
import ProtocolDetail from '@/components/modal/ProtocolDetail';
import FileUpload from '@/components/modal/FileUpload';
import HubHeader from '@/components/layout/HubHeader.vue';

export default {
  name: 'ProtocolWorkspace',
  components: {
    HubHeader,
    TagOptionPopTagAddList,
    registDictionaryPopup,
    ExperimentType,
    EditAttribute,
    EditAttributePool,
    ConnectProtocol,
    SearchProtocol,
    ProtocolDetail,
    FileUpload,
  },
  data() {
    return {
      registDictionaryPopupKey: 0,
      recentProtocol: null,
      editorMode: null,      // 'edit' | 'readonly' | null (에디터가 이벤트 버스로 알려줌)
      editorAuth: false,
      editorProtocolType: '',
    };
  },
  computed: {
    routeViewKey() {
      const { path, query } = this.$route;
      const documentKey = `${query.processId || ''}:${query.protocolId || ''}`;
      const gatewayActionKey = path === '/protocol/gate'
        ? `${query.action || ''}:${query.requestAt || ''}`
        : '';
      return `${path}:${documentKey}:${gatewayActionKey}`;
    },
    isGate() {
      return this.$route.path === '/protocol/gate';
    },
    isEditor() {
      return this.$route.path === '/protocol/editor';
    },
  },
  watch: {
    $route() {
      this.loadRecentProtocol();
      if (!this.isEditor) this.onEditorMode(null);
    },
  },
  mounted() {
    this.loadRecentProtocol();
    this.$root.$on('protocol-editor-mode', this.onEditorMode);
  },
  beforeDestroy() {
    this.$root.$off('protocol-editor-mode', this.onEditorMode);
  },
  methods: {
    onEditorMode(payload) {
      if (!payload) {
        this.editorMode = null;
        this.editorAuth = false;
        this.editorProtocolType = '';
        return;
      }
      this.editorMode = payload.mode;
      this.editorAuth = !!payload.isAuth;
      this.editorProtocolType = payload.protocolType || '';
    },
    loadRecentProtocol() {
      try {
        const recent = JSON.parse(sessionStorage.getItem('editor-url'));
        this.recentProtocol = recent &&
          recent.path === '/protocol/editor' &&
          recent.query &&
          recent.query.processId &&
          recent.query.protocolId
          ? recent
          : null;
      } catch (error) {
        this.recentProtocol = null;
      }
    },
    moveHome() {
      this.$router.push('/platform');
    },
    moveMypage() {
      this.$router.push('/account/mypage');
    },
    moveList() {
      this.$router.push({
        path: '/protocol/gate',
        query: { editorType: 'gate', listSearchType: 'recentList' },
      });
    },
    createProtocol() {
      this.$router.push({
        path: '/protocol/gate',
        query: { editorType: 'gate', action: 'create', requestAt: Date.now() },
      });
    },
    openRecentProtocol() {
      if (this.isEditor) return;
      if (this.recentProtocol) {
        this.$router.push(this.recentProtocol);
      }
    },
    runEditorAction(action) {
      const target = this.isEditor
        ? { path: this.$route.path, query: this.$route.query }
        : this.recentProtocol;

      if (!target) return;

      this.$router.push({
        path: target.path,
        query: {
          ...target.query,
          workspaceAction: action,
          requestAt: Date.now(),
        },
      });
    },
  },
};
</script>

<style lang="scss">
/* 에디터 내부 팝업들이 참조할 수 있어 전역 유지 (기존 셸에서도 로드하던 파일) */
@import "@/style/new/css/ui.common.css";
</style>

<style lang="scss" scoped>
/* ============================================
   프로토콜 워크스페이스 셸
   공통 헤더(HubHeader) 아래 라이트 레일 + 허브 네이비(#003f67) 단일 포인트
   ============================================ */
.ptlShell {
  --rail-bg: #fafbfc;
  --rail-line: #e7e9ee;
  --rail-text: #4b5260;
  --rail-text-dim: #9aa1ad;
  --rail-navy: #003f67;

  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #fff;
  /* 폰트는 전역(index.scss)과 동일하게 상속 */
  font-family: inherit;

  button { font: inherit; cursor: pointer; }
}
.ptlBody {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
}

/* ---------- 사이드 레일 ---------- */
.ptlSide {
  display: flex;
  flex-direction: column;
  flex: 0 0 190px;
  height: 100%;
  padding: 18px 12px 14px;
  background: var(--rail-bg);
  border-right: 1px solid var(--rail-line);
}

.sideHead {
  margin-bottom: 18px;
  padding: 0 6px 14px;
  border-bottom: 1px solid var(--rail-line);
}
.brand {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0;
  border: 0;
  background: none;

  .brandText {
    font-size: 13.5px;
    font-weight: 700;
    color: #1a2236;
  }
  .brandSub {
    font-size: 10.5px;
    font-weight: 500;
    color: var(--rail-text-dim);
  }

  &:hover {
    .brandText { color: var(--rail-navy); }
    .brandSub { color: var(--rail-text); }
  }
}

.newProtocolBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  width: 100%;
  height: 35px;
  margin-bottom: 18px;
  border: 0;
  border-radius: 9px;
  background: var(--rail-navy);
  color: #fff;
  font-size: 12.5px;
  font-weight: 700;
  transition: background 0.16s;

  .btnCode {
    font-size: 13px;
    opacity: 0.85;
  }

  &:hover { background: #0a3d9e; }
}

/* ---------- 내비게이션 ---------- */
.sideNav {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
.navLabel {
  margin: 0 0 5px;
  padding: 0 8px;
  font-size: 10px;
  font-weight: 500;
  color: var(--rail-text-dim);

  &:not(:first-child) { margin-top: 18px; }
}
.navItem {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 7px 10px;
  border: 0;
  border-radius: 7px;
  background: none;
  text-align: left;
  font-size: 12.5px;
  font-weight: 500;
  color: var(--rail-text);
  transition: background 0.14s, color 0.14s;

  .idx {
    min-width: 18px;
    font-size: 10.5px;
    font-variant-numeric: tabular-nums;
    color: var(--rail-text-dim);
    transition: color 0.14s;
  }

  &:hover:not(:disabled) {
    background: #f0f2f6;
    color: #1a2236;
  }
  &:disabled {
    color: #c4c9d2;
    cursor: default;
    .idx { color: #d4d8df; }
  }

  &.on {
    background: #e9eefa;
    color: var(--rail-navy);

    .idx { color: var(--rail-navy); }
  }

  &.saveItem {
    color: var(--rail-navy);
    font-weight: 700;

    .idx { color: var(--rail-navy); }

    &:hover:not(:disabled) {
      background: #e9eefa;
      color: var(--rail-navy);
    }
  }
}

/* ---------- 하단 유틸 ---------- */
.sideFoot {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  padding: 12px 8px 0;
  border-top: 1px solid var(--rail-line);

  button, a {
    padding: 0;
    border: 0;
    background: none;
    font-size: 11.5px;
    font-weight: 600;
    color: var(--rail-text-dim);
    text-decoration: none;

    &:hover { color: var(--rail-navy); }
  }
  .sep {
    width: 2px;
    height: 2px;
    border-radius: 50%;
    background: #ccd0d8;
  }
}

/* ---------- 콘텐츠 ---------- */
.ptlMain {
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  overflow: hidden;
}

/* ---------- 반응형 ---------- */
@media (max-width: 1024px) {
  .ptlBody {
    flex-direction: column;
  }

  .ptlSide {
    flex: 0 0 auto;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: auto;
    padding: 8px 12px;
    border-right: 0;
    border-bottom: 1px solid var(--rail-line);
    gap: 14px;
  }

  .sideHead {
    margin: 0;
    padding: 0;
    border-bottom: 0;
    flex-shrink: 0;
  }

  .newProtocolBtn {
    order: 3;
    width: auto;
    height: 32px;
    margin: 0 0 0 auto;
    padding: 0 14px;
    flex-shrink: 0;
    font-size: 12.5px;
  }

  .sideNav {
    flex-direction: row;
    align-items: center;
    gap: 2px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }
  .navLabel { display: none; }
  .navItem {
    width: auto;
    padding: 7px 10px;
    white-space: nowrap;
    font-size: 12.5px;

    .idx { display: none; }
  }

  .sideFoot { display: none; }

  .ptlMain {
    flex: 1 1 auto;
    min-height: 0;
  }
}
</style>
